import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment } from '@websky/graphql';
import { getBusinessLounge } from '@websky/core/src/Checkout/store/order/selectors';
import BusinessService from '../BusinessService/BusinessService';

const Business: React.FC = () => {
	const { t } = useTranslation('Checkout');

	const businessLoungeServices = useSelector(getBusinessLounge);

	const servicesByRfics = React.useMemo(() => {
		const servicesByRficsMap = new Map<string, GdsService_OrderAdditionalServiceGdsServiceVip_Fragment[]>();

		businessLoungeServices.forEach(service => {
			const key = service.rfisc;

			servicesByRficsMap.set(key, [...(servicesByRficsMap.get(key) ?? []), service]);
		});

		return [...servicesByRficsMap.values()];
	}, [businessLoungeServices]);

	if (!businessLoungeServices.length) {
		return null;
	}

	return (
		<>
			{servicesByRfics.map(services => {
				const service = services[0];

				return (
					<BusinessService key={service.id} header={service.name ?? t('Business lounge')} service={service} />
				);
			})}
		</>
	);
};

export default Business;
